export default "__VITE_PUBLIC_ASSET__08c50f2b__"